import { money } from "@/utils/numeral/money";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { GridKubernetesResourceDataResponse } from "@/store/resources-grid/utils/types/resources";

export const generateKubernetesResourceDetailsHeaderChipsData = (
  resource: GridKubernetesResourceDataResponse,
) => {
  const data = [
    { title: "Cluster", value: resource.resource.cluster?.name },
    {
      title: "Monthly Price",
      value: money(resource.resource.total_monthly_cost),
    },
  ];

  if ("instance_type" in resource.resource) {
    data.push({
      title: "Instance Type",
      value: resource.resource.instance_type,
    });
  }

  if ("region" in resource.resource) {
    data.push({ title: "Region", value: resource.resource.region });
  }

  if ("pod_count" in resource.resource) {
    data.push({ title: "Pods", value: `${resource.resource.pod_count}` });
  }

  if ("namespace" in resource.resource) {
    data.push({ title: "Namespace", value: resource.resource.namespace });
  }

  if ("generation" in resource.resource) {
    data.push({ title: "Generation", value: resource.resource.generation });
  }

  if ("strategy" in resource.resource) {
    data.push({ title: "Strategy", value: resource.resource.strategy });
  }

  if ("pod_management_policy" in resource.resource) {
    data.push({
      title: "Pod Management Policy",
      value: resource.resource.pod_management_policy,
    });
  }

  if ("node" in resource.resource) {
    data.push({
      title: "Node Name",
      value: resource.resource.node?.name ?? "",
    });
  }

  if ("creation_timestamp" in resource.resource) {
    data.push({
      title: "Creation Date",
      value: formatDate(resource.resource.creation_timestamp, {
        type: "date",
      }),
    });
  }

  if ("age_in_seconds" in resource.resource) {
    data.push({
      title: "Age",
      value: formatSecondsToFormattedDate(resource.resource.age_in_seconds),
    });
  }

  return data;
};

export const formatSecondsToFormattedDate = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(seconds / 3600);
  const days = Math.floor(seconds / oneDayInSeconds);
  const months = Math.floor(seconds / (oneDayInSeconds * 30));

  if (seconds < 3600) {
    return `${format(minutes)}min`;
  } else if (seconds < oneDayInSeconds) {
    return `${format(hours)}h`;
  } else if (seconds < oneDayInSeconds * 30) {
    const remainingHours = hours - days * 24;
    const remainingPart = remainingHours ? `${format(remainingHours)}h ` : "";

    return `${format(days)}d ${remainingPart}`;
  } else {
    const remainingDays = days - months * 30;
    const remainingPart = remainingDays ? `${format(remainingDays)}d ` : "";

    return `${format(months)}mo ${remainingPart}`;
  }
};

const format = (value: number) => value.toFixed(2).replace(/\.00$/, "");

export const oneDayInSeconds = 86400;
